import styled from "styled-components";
import { colors } from "../../utils/styles/colors";

export const ModalUploadVideoContainer = styled.div`
    position: fixed;
    overflow-y: auto;
    top:0;
    left: 0; 
    height: 100vh;
    width: 100vw;
    background-color: ${colors.footerBackground};
    display: flex;
    align-items: center;
    z-index: 100;
    display: flex;
    flex-direction: column;
    padding: 40px;
    .close{
        width: 40px;
        align-self: flex-end;
        cursor: pointer;
    }
    .uploadContainer{
        cursor: pointer;
        margin-top: 30px;
        background-color: ${colors.grey};
        padding: 30px;
        min-height: 80%;
        width: 350px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        text-align: center;
        .cameraIcon{
            width: 50px;
            cursor: pointer;
        }
        .subTitle{
            font-weight: 700;
            padding: 10px 0;
        }
        p{
            cursor: pointer;
        }
        input[type="file"]{
            display: none;
        }
    }
    .videoContainer{
        margin-top: 30px;
        background-color: ${colors.grey};
        width: 50%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        position: relative;
    }
    .videoEdit{
        background-color: rgba(51, 48, 48, 0.5);
        border-radius: 50%;
        position: absolute;
        padding: 10px;
        z-index: 50;
        top: 10px;
        right: 10px;
        width: 30px;
        height: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
        .editPhoto{
            cursor: pointer;
            width: 15px;
        }
        input[type="file"]{
            display: none;
        }
    }
    .video{
        width: 100%;
    }

`